import React from 'react';
import theme from './Footer.scss';

import {getMessage as msg} from '../../MessageBundle';

export default class Footer extends React.Component {


    render() {
        return (
            <footer>
                <span>{msg('newComplaint.footer.copyright')}</span>
                <a href={msg('newComplaint.footer.link.AGB')} target='_blank'>
                    {msg('newComplaint.footer.AGB')}
                </a>
                <a href={msg('newComplaint.footer.link.Disclaimer')} target='_blank'>
                    {msg('newComplaint.footer.Disclaimer')}
                </a>
                <a href={msg('newComplaint.footer.link.environmentalism')} target='_blank'>
                    {msg('newComplaint.footer.environmentalism')}
                </a>
                <a href="/contacts" target='_blank'>
                    {msg('newComplaint.footer.imprintAndContact')}
                </a>
                <a href={msg('newComplaint.footer.link.dataProtection')} target='_blank'>
                    {msg('newComplaint.footer.dataProtection')}
                </a>
                <a href="/instructions" target='_blank'>
                    {msg('newComplaint.footer.processingInstructions')}
                </a>
            </footer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/Footer/index.js